"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectOuterMostNodeForSelectedText = selectOuterMostNodeForSelectedText;
exports.removeElementsFromRange = removeElementsFromRange;
exports.removeSpanStyleFromRange = removeSpanStyleFromRange;
exports.applyLineHeight = applyLineHeight;
exports.applyFontSize = applyFontSize;
exports.applyFontStyles = applyFontStyles;
exports.getContentOfSelection = exports.clearRngContent = exports.shouldApplyOverrideFormat = exports.isLinebreakNode = exports.isNestedOnlyChild = exports.isNestedLastChild = exports.isNestedFirstChild = exports.isLastChild = exports.isFirstChild = void 0;

var _tinymce = _interopRequireDefault(require("tinymce"));

var _hsformatting = require("tinymce-plugins/constants/hsformatting");

var _formatting = require("../utils/formatting");

var _settings = require("../utils/settings");

var _getComputedStyle = require("../utils/getComputedStyle");

var _utils = require("../utils");

var isFirstChild = function isFirstChild(node, parentNode) {
  var parent = parentNode || node.parentNode;
  return parent && node === parent.firstChild;
};

exports.isFirstChild = isFirstChild;

var isLastChild = function isLastChild(node, parentNode) {
  var parent = parentNode || node.parentNode;
  return parent && node === parent.lastChild;
};

exports.isLastChild = isLastChild;

var isNestedFirstChild = function isNestedFirstChild(node, parentNode) {
  if (node === parentNode) return true;

  if (isFirstChild(node)) {
    return isNestedFirstChild(node.parentNode, parentNode);
  }

  return false;
};

exports.isNestedFirstChild = isNestedFirstChild;

var isNestedLastChild = function isNestedLastChild(node, parentNode) {
  if (node === parentNode) return true;

  if (isLastChild(node)) {
    return isNestedLastChild(node.parentNode, parentNode);
  }

  return false;
};

exports.isNestedLastChild = isNestedLastChild;

var isNestedOnlyChild = function isNestedOnlyChild(node, parent) {
  if (node === parent) return true;

  if (isFirstChild(node) && isLastChild(node)) {
    return isNestedOnlyChild(node.parentNode, parent);
  }

  return false;
};

exports.isNestedOnlyChild = isNestedOnlyChild;

var isLinebreakNode = function isLinebreakNode(node) {
  if (node.nodeName === 'BR') return true;
  if (node.childNodes.length !== 1) return false;
  return isLinebreakNode(node.childNodes[0]);
};

exports.isLinebreakNode = isLinebreakNode;

function selectOuterMostNodeForSelectedText(editor) {
  // get outer most node of range
  var range = editor.selection.getRng();
  var text = range.toString();

  if (range.commonAncestorContainer.textContent !== text) {
    return range;
  }

  var outerMostWrapper = range.commonAncestorContainer;
  var lastWrapper = outerMostWrapper;

  while (outerMostWrapper !== editor.getBody() && outerMostWrapper.textContent === text) {
    lastWrapper = outerMostWrapper;
    outerMostWrapper = outerMostWrapper.parentNode;
  }

  var newRange = editor.getDoc().createRange();
  newRange.setStart(lastWrapper, 0);
  newRange.setEnd(lastWrapper, lastWrapper.childNodes.length);
  return newRange;
}

function removeElementsFromRange(editor, range, nodeNames) {
  var RangeUtils = _tinymce.default.dom.RangeUtils;
  var rangeUtils = new RangeUtils(editor.dom);
  var nodesToProcess = [];

  var removeNode = function removeNode(node) {
    editor.dom.remove(node, true);
  };

  var maybeAddNode = function maybeAddNode(node) {
    if (nodeNames.includes(node.nodeName.toLowerCase())) {
      nodesToProcess.push(node);
    }
  };

  rangeUtils.walk(range, function (nodes) {
    nodes.forEach(function (node) {
      maybeAddNode(node);

      if (node.hasChildNodes()) {
        var elements = node.querySelectorAll(nodeNames.join(','));

        if (elements.length) {
          Array.from(elements).forEach(maybeAddNode);
        }
      }
    });
  });

  if (nodesToProcess.length) {
    nodesToProcess.forEach(removeNode);
  }
}

function removeSpanStyleFromRange(editor, range, style) {
  var RangeUtils = _tinymce.default.dom.RangeUtils;
  var rangeUtils = new RangeUtils(editor.dom);
  var nodesToProcess = [];

  var removeNakedSpans = function removeNakedSpans(node) {
    if (node.attributes.length === 1 && node.hasAttribute('style') && !node.getAttribute('style')) {
      editor.dom.remove(node, true);
    }
  };

  var maybeAddNode = function maybeAddNode(node) {
    if (node.nodeName === 'SPAN' && editor.dom.getStyle(node, style)) {
      nodesToProcess.push(node);
    }
  };

  rangeUtils.walk(range, function (nodes) {
    nodes.forEach(function (node) {
      maybeAddNode(node);

      if (node.hasChildNodes()) {
        var spans = node.querySelectorAll('span[style]');

        if (spans.length) {
          Array.from(spans).forEach(maybeAddNode);
        }
      }
    });
  });

  if (nodesToProcess.length) {
    editor.dom.setStyle(nodesToProcess, style, null);
    nodesToProcess.forEach(removeNakedSpans);
  }
}

function getLineheightAsPercentage(value) {
  if (isNaN(value)) {
    return value;
  }

  return Math.round(Number(value) * 100) + "%";
}
/**
 * Get the whitelisted block element that starts the range if the range
 * starts at the beginning of the block
 *
 * @param {Object} editor Instance of a TinyMCE Editor
 * @param {Range} range Range object typically from a Selection
 * @param {Array} blocks array that provides a whitelist of possible node names
 *
 * @return {null|HTMLElement} a block element or null
 */


function getRangeStartBlock(editor, range, nodeWhitelist) {
  // If the offset is not 0 we know that
  // the range isn't at the start
  if (range.startOffset !== 0 && !range.collapsed) {
    return null;
  }

  var start = range.startContainer;

  if (start.nodeType === Node.TEXT_NODE) {
    // If the parent node of a text node is the editor
    // body, we no that a content block is not range
    if (start.parentNode === editor.getBody()) {
      return null;
    } // If the text node is not the first child of the
    // parent element, the range is not at the beginning
    // of a block


    if (start.parentNode.firstChild !== start) {
      return null;
    } // The selection begins at the first character of a text node,
    // so we can safely say that the start of the range is the
    // parent node


    start = start.parentNode;
  } else if (start.nodeType !== Node.ELEMENT_NODE) {
    return null;
  } // If the start is a block, we know that the range is starting
  // at the beginning of the block


  if (nodeWhitelist.includes(start.nodeName.toLowerCase())) {
    return start;
  }

  var ancestors = editor.$(start).parentsUntil(editor.getBody());

  if (!ancestors || ancestors.length === 0) {
    return null;
  }

  var child = start;
  var startBlock = null; // Search ancestors as long as the current elem is the first child
  // of the ancestor to determine if the range starts at block elem

  ancestors.each(function (index, elem) {
    if (nodeWhitelist.includes(elem.nodeName.toLowerCase()) && elem.firstChild === child) {
      startBlock = elem;
      return false;
    }

    child = elem;
    return true;
  });
  return startBlock;
}
/**
 * Get the whitelisted  block element that ends the range
 *
 * @param {Object} editor instance of a TinyMCE Editor
 * @param {Range} range range object typically from a Selection
 * @param {Array} nodeWhitelist a whitelist of possible node names
 *
 * @return {null|HTMLElement} a block element or null
 */


function getRangeEndBlock(editor, range, nodeWhitelist) {
  var end = range.endContainer;

  if (end.nodeType === Node.ELEMENT_NODE) {
    // The range must end after the last node
    // when the end container is an element node
    if (range.endOffset < end.childNodes.length) {
      return null;
    }
  } else if (end.nodeType === Node.TEXT_NODE) {
    // The range must end after the last character
    // the end container is a text node
    if (range.endOffset !== end.length) {
      return null;
    } // If the parent node is not a node in the TinyMCE editor
    // body we can assume that a block element in the content
    // is not the end of the selection


    if (end.parentNode === editor.getBody()) {
      return null;
    } // Verify that the text node is the last node in the parent


    if (end.parentNode.childNodes[end.parentNode.childNodes.length - 1] !== end) {
      return null;
    } // Since the text node is the last node, we can assume that the parent of the
    // text node is the end


    end = end.parentNode;
  } else {
    return null;
  } // If the current end node is a whitelisted node name then
  // the range ends at at the end of a block


  if (nodeWhitelist.includes(end.nodeName.toLowerCase())) {
    return end;
  }

  var ancestors = editor.$(end).parentsUntil(editor.getBody());

  if (!ancestors || ancestors.length === 0) {
    return null;
  }

  var child = end;
  var endBlock = null; // Search ancestors as long as the current elem is the last child
  // of the ancestor to determine if the range ends at a
  // whitelisted block elem

  ancestors.each(function (index, elem) {
    if (nodeWhitelist.includes(elem.nodeName.toLowerCase()) && elem.childNodes[elem.childNodes.length - 1] === child) {
      endBlock = elem;
      return false;
    }

    child = elem;
    return true;
  });
  return endBlock;
}

function areEntireBlocksSelected(editor, nodeWhitelist) {
  var range = editor.selection.getRng();
  var startBlock = getRangeStartBlock(editor, range, nodeWhitelist);

  if (editor.selection.isCollapsed() && startBlock || startBlock && getRangeEndBlock(editor, range, nodeWhitelist)) {
    return true;
  }

  return false;
}

function applyLineHeight(editor, lineHeight) {
  var applyAsPercentage = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.APPLY_LINE_HEIGHT_PERCENTAGE, false);

  if (applyAsPercentage) {
    lineHeight = getLineheightAsPercentage(lineHeight);
  }

  editor.undoManager.transact(function () {
    removeSpanStyleFromRange(editor, editor.selection.getRng(), 'line-height');
    editor.formatter.apply(_hsformatting.LINE_HEIGHT_FORMAT, {
      value: lineHeight
    });
  });
  return lineHeight;
}

function applyFontSize(editor, fontSize) {
  var usePercentage = (0, _utils.getHsformattingSettings)(editor.settings, _hsformatting.hsformattingConfig.APPLY_LINE_HEIGHT_PERCENTAGE, false);

  if (((0, _settings.isUngated)(editor, _hsformatting.BLOCK_FONT_SIZE_GATE) || usePercentage) && areEntireBlocksSelected(editor, _hsformatting.FONT_SIZE_BLOCKS)) {
    // Default to a value that corresponds to the typical `normal` value
    var lineHeight = 1.25;

    if (usePercentage) {
      var node = editor.selection.getNode();

      if (node) {
        var computedStyle = (0, _getComputedStyle.maybeGetComputedStyle)(editor.getWin(), node);

        if (computedStyle) {
          var currentLineHeight = parseFloat(computedStyle['line-height']);
          var currentFontSize = parseFloat(computedStyle['font-size']);

          if (!isNaN(currentLineHeight) && !isNaN(currentFontSize)) {
            lineHeight = currentLineHeight / currentFontSize;
          }
        }
      }
    }

    var startBlock = getRangeStartBlock(editor, editor.selection.getRng(), _hsformatting.FONT_SIZE_BLOCKS);
    var endBlock = getRangeEndBlock(editor, editor.selection.getRng(), _hsformatting.FONT_SIZE_BLOCKS) || startBlock;
    var range = editor.getDoc().createRange(); // Create range that extends to cover the entire block so that parent spans are removed

    range.setStart(startBlock, 0);
    range.setEnd(endBlock, endBlock.childNodes.length);
    removeSpanStyleFromRange(editor, range, 'font-size');
    editor.formatter.apply(_hsformatting.BLOCK_FONT_SIZE_FORMAT, {
      value: fontSize
    });

    if (usePercentage) {
      range.setEnd(endBlock, endBlock.childNodes.length);
      removeSpanStyleFromRange(editor, range, 'line-height');
      editor.formatter.apply(_hsformatting.LINE_HEIGHT_FORMAT, {
        value: getLineheightAsPercentage(lineHeight)
      });
    }

    return;
  }

  editor.formatter.apply('fontsize', {
    value: fontSize
  });
}

var shouldApplyOverrideFormat = function shouldApplyOverrideFormat(editor) {
  var overrideFormats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  if (overrideFormats.length === 0) {
    return false;
  }

  if (areEntireBlocksSelected(editor, overrideFormats) || overrideFormats.includes(editor.selection.getNode().nodeName.toLowerCase())) {
    return true;
  }

  var selectedBlocks = editor.selection.getSelectedBlocks();
  var selector = overrideFormats.join(',');
  return !!selectedBlocks.find(function (element) {
    return overrideFormats.includes(element.nodeName.toLowerCase()) || !!element.querySelector(selector);
  });
};

exports.shouldApplyOverrideFormat = shouldApplyOverrideFormat;

function applyFontStyles(editor, format, overrideFormats, enabled) {
  if (overrideFormats.length > 0 && shouldApplyOverrideFormat(editor, overrideFormats)) {
    editor.undoManager.transact(function () {
      // handle <a> node
      // if (format === 'underline') {
      //   overrideLinkNodeFormatting(editor);
      // }
      editor.formatter.remove(_formatting.overrideInheritedStyles[format].tinyMCECommand);
      editor.formatter.remove(_hsformatting.FORMAT_COMMAND_TO_INHERITED_COMMAND[format].on, {
        value: _formatting.overrideInheritedStyles[format][enabled ? 'off' : 'on']
      });
      editor.formatter.apply(_hsformatting.FORMAT_COMMAND_TO_INHERITED_COMMAND[format].on, {
        value: _formatting.overrideInheritedStyles[format][enabled ? 'on' : 'off']
      });

      if (!enabled) {
        //remove all formats applied to non-overriden elements
        editor.formatter.remove(_hsformatting.FORMAT_COMMAND_TO_INHERITED_COMMAND[format].off);
      }
    });
    return;
  }

  editor.execCommand('mceToggleFormat', false, format);
}

var clearRngContent = function clearRngContent(editor, rng, startNode, endNode) {
  rng.setStartBefore(startNode);
  rng.setEndAfter(endNode);
  editor.selection.setRng(rng);
  editor.selection.setContent('');
};

exports.clearRngContent = clearRngContent;

var getContentOfSelection = function getContentOfSelection(editor, rng, startNode, endNode) {
  rng.setStartBefore(startNode);
  rng.setEndAfter(endNode);
  editor.selection.setRng(rng);
  return editor.selection.getContent();
};

exports.getContentOfSelection = getContentOfSelection;